// Force a standing so the tiered calendar can be looked at from every rung
// without earning four of them by hand.
//
// Display only, and dev only. Nothing here is sent anywhere: every route
// resolves standing from the database itself, so a forced rank shows you
// the controls and then gets a 403 the moment you press one.
//
//   ?rank=new | knows | familiar | own
//   ?rank=0..3   the same four, bottom up
//   ?rank=25     read as a kept-offering count
//
// NEXT_PUBLIC_RANK_PREVIEW=1 turns it on for a deploy if the interface ever
// needs reviewing somewhere other than localhost.

const ALIAS = { new: 0, knows: 1, familiar: 3, own: 10 }
const LADDER = [0, 1, 3, 10]

export const RANK_PREVIEW_ON =
  process.env.NODE_ENV !== 'production' || process.env.NEXT_PUBLIC_RANK_PREVIEW === '1'

/** The kept-offering count to pretend we have, or null when not previewing. */
export function previewAccepted() {
  if (!RANK_PREVIEW_ON || typeof window === 'undefined') return null
  const raw = new URLSearchParams(window.location.search).get('rank')
  if (raw == null) return null

  const key = raw.trim().toLowerCase()
  if (key in ALIAS) return ALIAS[key]

  const n = Number(key)
  if (!Number.isFinite(n) || n < 0) return null
  return n <= 3 ? LADDER[Math.round(n)] : Math.round(n)
}

/**
 * `?demo=1`: stand a sample ballot up so the voting interface can be looked
 * at before the town has anything to decide. Same dev-only gate. The card
 * says SAMPLE on it and its votes go nowhere.
 */
export function demoRequested() {
  if (!RANK_PREVIEW_ON || typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('demo') === '1'
}

export const SAMPLE_BALLOT = {
  id: 'sample',
  sample: true,
  question: 'What plays at the cinema on Friday?',
  kind: 'film',
  place: 'cinema',
  status: 'open',
  options: [
    { id: 's1', title: 'The Long Way Round the Harbour', blurb: 'a boat that never leaves, and the man who keeps it ready', votes: 9 },
    { id: 's2', title: 'Everything the Tide Took', blurb: 'a year of things found on one beach', votes: 6 },
    { id: 's3', title: 'Sixty Trains', blurb: 'no narration, just the 4:40 through, sixty times', votes: 2 },
  ],
}
